var l = Object.defineProperty;
var d = (t, e, i) => e in t ? l(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var a = (t, e, i) => d(t, typeof e != "symbol" ? e + "" : e, i);
import { defineComponent as u } from "vue";
class c {
  constructor() {
    a(this, "events", {});
  }
  on(e, i) {
    this.events[e] || (this.events[e] = []), this.events[e].push(i);
  }
  off(e, i) {
    this.events[e] && (this.events[e] = this.events[e].filter((r) => r !== i));
  }
  emit(e, ...i) {
    this.events[e] && this.events[e].forEach((r) => r(...i));
  }
}
const o = new c(), f = u({
  name: "VueTurnstile",
  emits: ["rendering", "rendered", "verified", "error"],
  props: {
    siteKey: {
      type: String,
      required: !0
    },
    theme: {
      type: String,
      required: !1,
      default: "auto"
    },
    size: {
      type: String,
      required: !1,
      default: "normal"
    },
    autoReset: {
      type: Boolean,
      required: !1,
      default: !1
    },
    resetTimeout: {
      type: Number,
      required: !1,
      default: 295 * 1e3
    },
    recaptchaCompat: {
      type: Boolean,
      required: !1,
      default: !1
    },
    explicitRender: {
      type: Boolean,
      required: !1,
      default: !1
    },
    appearance: {
      type: String,
      required: !1,
      default: "always"
    },
    language: {
      type: String,
      required: !1,
      default: "auto"
    }
  },
  data() {
    return {
      widgetId: null
    };
  },
  methods: {
    initTurnstile() {
      const t = document.createElement("script"), e = "https://challenges.cloudflare.com/turnstile/v0/api.js", i = "onloadTurnstileCallback", r = this.recaptchaCompat ? "&compat=recaptcha" : "", s = this.explicitRender ? "&render=explicit" : "";
      t.src = `${e}?onload=${i}${r}${s}`, t.async = !0, t.defer = !0, document.head.appendChild(t);
    },
    reset() {
      window.turnstile && window.turnstile.reset(this.widgetId);
    },
    remove() {
      this.widgetId && (window.turnstile.remove(this.widgetId), this.widgetId = null);
    },
    async execute() {
      return new Promise((t, e) => {
        try {
          const i = (r) => {
            o.off("verified", i), t(r);
          };
          o.on("verified", i), this.render();
        } catch (i) {
          e(i);
        }
      });
    },
    render() {
      this.widgetId = window.turnstile.render("#cf-turnstile", {
        sitekey: this.siteKey,
        theme: this.theme,
        size: this.size,
        appearance: this.appearance,
        language: this.language,
        callback: (t) => {
          this.$emit("verified", t), this.remove(), this.autoReset && setTimeout(() => {
            this.reset();
          }, this.resetTimeout);
        },
        "expired-callback": () => {
          this.reset();
        },
        "error-callback": (t) => {
          console.error(`Error callback: ${t}`), this.$emit("error", t);
        }
      }), this.$emit("rendered");
    },
    onloadTurnstileCallback() {
      window.onloadTurnstileCallback = () => {
        this.render();
      };
    }
  },
  beforeMount() {
    (window.turnstile === void 0 || !window.turnstile) && this.initTurnstile();
  },
  mounted() {
    this.$emit("rendering"), window.turnstile === void 0 || !window.turnstile ? this.onloadTurnstileCallback() : this.render();
  },
  beforeUnmount() {
    this.remove();
  }
});
function h(t, e, i, r, s, v, g, y) {
  var n = typeof t == "function" ? t.options : t;
  return e && (n.render = e, n.staticRenderFns = i, n._compiled = !0), {
    exports: t,
    options: n
  };
}
var m = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, i("div", { attrs: { id: "cf-turnstile" } }, [e._t("default")], 2);
}, p = [], w = /* @__PURE__ */ h(
  f,
  m,
  p
);
const T = w.exports;
export {
  T as default
};
